var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',_vm._b({attrs:{"type":_vm.tipoGrafico,"options":_vm.opcoesGrafico,"series":_vm.series,"height":_vm.height},on:{"click":_vm.clickEmit}},'apexchart',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }